import { definePreset, palette } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import {
  accordion,
  autocomplete,
  badge,
  button,
  card,
  checkbox,
  chip,
  datatable,
  datepicker,
  dialog,
  divider,
  drawer,
  editor,
  fileupload,
  iconfield,
  inputgroup,
  inputtext,
  menu,
  message,
  multiselect,
  paginator,
  popover,
  progressbar,
  select,
  selectbutton,
  skeleton,
  stepper,
  tabs,
  tabview,
  tag,
  textarea,
  tieredmenu,
  togglebutton,
  toggleswitch,
  treeselect,
} from './components';

// const testPalette = palette('#55c013');
// const primaryColorPalette = palette('#1E3A8A');
const primaryColorPalette = palette('#003c5b');
const primaryDarkColorPalette = palette('#45bfa2');
const accentColorPalette = palette('#ffc107');
const surfaceDarkPalette = palette('#333643');
const surfaceLightPalette = palette('#efefef');
// console.log(surfaceDarkPalette);
// console.log(surfaceLightPalette);

const CustomTheme = definePreset(Aura, {
  semantic: {
    // primary: testPalette,
    primary: primaryColorPalette,
    primaryDark: primaryDarkColorPalette,
    // primary: {
    //   50: '{blue.50}',
    //   100: '{blue.100}',
    //   200: '{blue.200}',
    //   300: '{blue.300}',
    //   400: '{blue.400}',
    //   500: '{blue.500}',
    //   600: '{blue.600}',
    //   700: '{blue.700}',
    //   800: '{blue.800}',
    //   900: '{blue.900}',
    //   950: '{blue.950}',
    // },
    // accentColor: accentColorPalette,

    colorScheme: {
      light: {
        themeMode: 'light',
        color: '{neutral.50}',
        // TS-336: paleta Connect24 v2 -- ver variables globales en styles.scss.
        textColor: '#5b6b7c',
        inverseTextColor: '{neutral.50}',
        primary: {
          color: '{primary.500}',
          inverseColor: '{primary.50}',
          hoverColor: '{primary.700}',
          activeColor: '{primary.500}',
        },
        severityColor: {
          success: '#12a972',
          warning: '#b0791e',
          info: '#14a08c',
          danger: '#d2534a',
          disabled: '#b3c2c7ff',
          border: {
            success: '#0e8a5c',
            warning: '#8f5f14',
            info: '#0f7a69',
            danger: '#b23f37',
            disabled: '#cadae0',
          },
        },
        // highlight: {
        //   background: '{zinc.950}',
        //   focusBackground: '{zinc.700}',
        //   color: '#ffffff',
        //   focusColor: '#ffffff',
        // },
        // surface: {
        //   0: '#ffffff',
        //   50: '{zinc.50}',
        //   100: '{zinc.100}',
        //   200: '{zinc.200}',
        //   300: '{zinc.300}',
        //   400: '{zinc.400}',
        //   500: '{zinc.500}',
        //   600: '{zinc.600}',
        //   700: '{zinc.700}',
        //   800: '{zinc.800}',
        //   900: '{zinc.900}',
        //   950: '{zinc.950}',
        // },
        // TS-336: antes era una escala gris pura -- ahora tiene el tinte
        // "ice/navy" de la maqueta v2, pero MANTIENE la misma curva de
        // claridad que la escala gris original (muy clara hasta el 500,
        // solo se vuelve gris/azulada visible a partir del 600). Muchos
        // sitios de la app (p.ej. el fondo general en _main.scss) usan
        // `--p-surface-500` directamente esperando un tono casi blanco --
        // si aquí se pone algo más oscuro (p.ej. el --slate-light de la
        // maqueta), esos fondos se vuelven visiblemente grises/azulados.
        bgColor: '#f7fafb',
        surface: {
          0: '#ffffff',
          '50': '#fbfdfd',
          '100': '#f5f9fa',
          '200': '#eef4f7', // --ice
          '300': '#e3eaef', // --border
          '400': '#d3dee5',
          '500': '#c3d2da',
          '600': '#93a3b2', // --slate-light
          '700': '#5b6b7c', // --slate
          '800': '#3d4d5f',
          '900': '#23384d',
          '950': '#0e2a4a', // --navy

          // '0': '#3c3c3c',
          // '50': '#606060',
          // '100': '#838383',
          // '200': '#a7a7a7',
          // '300': '#cbcbcb',
          // '400': '#efefef',
          // '500': '#f2f2f2',
          // '600': '#f5f5f5',
          // '700': '#f8f8f8',
          // '800': '#fbfbfb',
          // '900': '#fefefe',
          // '950': '#ffffff',

          // '0': '#24262f',
          // '50': '#3c3c3c',
          // '100': '#606060',
          // '200': '#7a7a7a',
          // '300': '#838383',
          // '400': '#a7a7a7',
          // '500': '#dadada',
          // '600': '#e8e8e8',
          // '700': '#efefef',
          // '800': '#f8f8f8',
          // '900': '#fafafa',
          // '950': '#ffffff',

          // Estilo grises
          // '0': '#1c1e25',
          // '50': '#24262f',
          // '100': '#3c3c3c',
          // '200': '#5a5c67',
          // '300': '#606060',
          // '400': '#838383',
          // '500': '#a7a7a7',
          // '600': '#cbcbcb',
          // '700': '#efefef',
          // '800': '#f8f8f8',
          // '900': '#fefefe',
          // '950': '#ffffff',
        },
        // cardBgColor: '#f8f8f8',
        cardBgColor: '#ffffff',
        formField: {
          background: '#ffffff',
          hoverBorderColor: '#14a08c',
          placeholder: {
            color: '{text.color}',
          },
          disabled: {
            background: '#e3eaef',
            color: '#93a3b2',
          },
        },
        sidebar: {
          logo: {
            // bgColor: '{primary.500}',
            bgColor: '{primary.500}',
          },
          bgColor: 'white',
          color: '#0e2a4a',
          hoverColor: '{white.100}',

          /* Active MenuItem */
          menuitem: {
            textColor: '#0e2a4a',
            textIconColor: '#274c6e',
            active: {
              textColor: 'white',
              iconTextColor: 'white',
              bgColor: '{primary.500}',
            },
            hover: {
              bgColor: 'rgba(0, 60, 91, 0.06)',
              textColor: '#0e2a4a',
              iconTextColor: '#274c6e',
            },
          },
          // TS-349: la fila seleccionada dentro de un módulo desplegado
          // (p.ej. "General" en "Frío - Cool Protect") se pinta ahora igual
          // que el hover (menuitem.hover, arriba) -- antes usaba un color
          // sólido bastante más fuerte, y el activo se veía como un estado
          // muy distinto del hover en vez de "esta fila, fijo".
          submenuitem: {
            active: {
              textColor: '#0e2a4a',
              iconTextColor: '#274c6e',
              bgColor: 'rgba(0, 60, 91, 0.06)',
            },
          },
        },
        header: {
          menu: {
            iconColor: '{neutral.50}',
            bgColor: '{primary.500}',
            // bgColor: 'white',
          },
        },
        icons: {
          color: '#14a08c',
        },
        mobile: {
          contentMaskBgColor: '424242',
        },
      },
      dark: {
        themeMode: 'dark',
        color: 'white',
        textColor: 'white',
        inverseTextColor: '{neutral.900}',
        primary: {
          color: '{primaryDark.500}',
          inverseColor: '{primaryDark.100}',
          hoverColor: '{primaryDark.300}',
          activeColor: '{primaryDark.200}',
        },
        severityColor: {
          success: '#35b481b9',
          warning: '#ce8b3ec4',
          info: '#45bfa2',
          danger: '#c5545dc0',
          disabled: '#b3c2c7be',
          border: {
            success: '#27a573b4',
            warning: '#ac702bbe',
            info: '#45bfa2',
            danger: '#b9404ab9',
            disabled: '#cadae0a8',
          },
        },
        // highlight: {
        //   background: '#f00',
        //   focusBackground: '#ff1',
        //   color: 'rgba(255,255,255,.87)',
        //   focusColor: 'rgba(255,255,255,.87)',
        // },
        // surface: {
        //   0: '#ffffff',
        //   50: '{slate.50}',
        //   100: '{slate.100}',
        //   200: '{slate.200}',
        //   300: '{slate.300}',
        //   400: '{slate.400}',
        //   500: '{slate.500}',
        //   600: '{slate.600}',
        //   700: '{slate.700}',
        //   800: '{slate.800}',
        //   900: '{slate.900}',
        //   950: '{slate.950}',
        // },
        bgColor: `$dt('surface.500')`,
        surface: {
          0: '#ffffff',
          '50': '#f5f5f6',
          '100': '#cecfd2',
          '200': '#a7a9ae',
          '300': '#81828a',
          '400': '#5a5c67',
          '500': '#333643',
          '600': '#2b2e39',
          '700': '#24262f',
          '800': '#1c1e25',
          '900': '#14161b',
          '950': '#0d0e11',
        },
        cardBgColor: '#3C434F',
        formField: {
          background: '#333643',
          hoverBorderColor: '{primary.color}',
          focusRing: {
            width: '2px',
            style: 'dashed',
            color: '{primary.color}',
            offset: '1px',
          },
          disabled: {
            background: '#3A3A49', // 4a4a5a
            color: '#4D4D55',
          },
        },
        sidebar: {
          logo: {
            bgColor: '{surface.700}',
          },
          bgColor: '{surface.600}',
          color: 'white',
          hoverColor: '{white.100}',

          /* Active MenuItem */
          menuitem: {
            textColor: 'white',
            textIconColor: '#1e88e5',
            active: {
              textColor: 'white',
              iconTextColor: 'white',
              bgColor: '{primary.400}',
            },
            hover: {
              bgColor: '{primary.200}',
              textColor: '#212121',
              iconTextColor: '#212121',
            },
          },

          // TS-349: mismo criterio que en el tema claro, arriba.
          submenuitem: {
            active: {
              textColor: '#212121',
              iconTextColor: '#212121',
              bgColor: '{primary.200}',
            },
          },
        },
        header: {
          menu: {
            iconColor: '{neutral.50}',
            bgColor: '{surface.700}',
          },
        },
        icons: {
          color: '#45bfa2',
        },
        mobile: {
          contentMaskBgColor: '424242',
        },
        topbar: {
          bgColor: '{surface.600}',
          color: '{neutral.50}',
        },
      },
    },
    mobile: {
      breakpoint: '1024px',
    },
    // TS-336: radio de esquina de la maqueta v2 (9-12px según el elemento;
    // este token es el que heredan por defecto botones, inputs, chips,
    // diálogos, popovers... salvo que el propio componente lo pise). La
    // sidebar tiene sus propios radios fijos (6px) en _main.scss, así que
    // este cambio no la afecta -- queda aparte para más adelante.
    borderRadius: '10px',
    fontSize: '1rem',
    transitionDuration: '0.3s',
    // TS-336: barra de cabecera de las páginas de listado (instalaciones,
    // sensores, things, incidencias...) -- blanca con texto navy, igual que
    // las cabeceras de card de la maqueta v2.
    topbar: {
      bgColor: '#ffffff',
      color: '#0e2a4a',
    },
  },

  components: {
    datatable,
    dialog,
    paginator,
    selectbutton,
    badge,
    togglebutton,
    editor,
    message,
    toggleswitch,
    progressbar,
    autocomplete,
    button,
    chip,
    drawer,
    card,
    inputgroup,
    iconfield,
    select,
    divider,
    multiselect,
    treeselect,
    checkbox,
    tieredmenu,
    tag,
    accordion,
    inputtext,
    textarea,
    fileupload,
    stepper,
    skeleton,
    menu,
    datepicker,
    popover,
    tabs,
    tabview,
    // common tokens and styles
    // extend: {
    //   my: {
    //     transition: {
    //       slow: '0.75s',
    //       normal: '0.5s',
    //       fast: '0.25s',
    //     },
    //     imageDisplay: 'block',
    //   },
    // },
    // css: ({ dt }: { dt: (key: string) => string }) => `
    //     /* Global CSS */
    //     img {
    //         display: ${dt('my.image.display')};
    //     }
    // `,
  },
});

export { CustomTheme };
